module.exports = __webpack_public_path__ + "img/art-m.37251fa.jpg";